export default __webpack_public_path__ + "static/media/delivery.97f3911c.svg";